export default "__VITE_ASSET__Hp0_JzK0__"